module.exports = __webpack_public_path__ + "img/sch.8b89eb33.svg";